import React from "react";
import Confetti from "react-confetti";

const Thankyou = ({ width, height }) => {
  //   const [showConfetti, setShowConfetti] = useState(true);

  //   useEffect(() => {
  //     const timer = setTimeout(() => {
  //       setShowConfetti(false);
  //     }, 10000);

  //     return () => clearTimeout(timer);
  //   }, []);

  return (
    <div className="text-center thankyou">
      {
        //   showConfetti &&
        <Confetti
          width={width}
          height={height}
          recycle={false}
          run={true}
          //   tweenDuration={10000}
        />
      }
      <h1>Thank You!</h1>
      <p>You have successfully registered.</p>
    </div>
  );
};

export default Thankyou;
